/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { useRef, useCallback, useState } from 'react';
import { RiCustomerService2Fill } from 'react-icons/ri';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { ImLocation2 } from 'react-icons/im';
import { FaPhoneAlt } from 'react-icons/fa';
import { GrMail } from 'react-icons/gr';
import { useToast } from '../../hooks/toast';
import ManualModal from './Components/ManualModal';
import Button from '../../components/Button';
import Input from '../../components/Input';
import framefacebook from '../../assets/framefacebook.svg';
import framewhatsapp from '../../assets/framewhatsapp.svg';
import frametelegram from '../../assets/frametelegram.svg';
import api from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';
import CoreService from '../../services/core';
import { Row, Column, InfoContainer, InfoItem } from '../../styles/components';

import {
  Container,
  Title,
  Content,
  Main,
  GridContainer,
  FlexContainer,
  FormWrapper,
  ModalRemoteAcess,
  FormWrappeEspecial,
} from './styles';
import Modal from '../../components/Modal';

interface ContactSectionProps {
  isPage?: boolean;
  isButtonLarge?: boolean;
}

const Suporte: React.FC<ContactSectionProps> = ({
  isPage = false,
  isButtonLarge = false,
  ...rest
}) => {
  const services = { coreService: new CoreService() };
  const formRef = useRef<FormHandles>(null);
  const formRefAcess = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [showManual, setShowManual] = useState<boolean>(false);
  const [modalRemoteAcess, setModalRemoteAcess] = useState(false);
  const [modalRemoteAcessCancel, setModalRemoteAcessCancel] = useState(false);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome é obrigatório'),
          email: Yup.string()
            .required('E-mail é obrigatório')
            .email('Digite um email válido'),
          phone: Yup.string(),
          comment: Yup.string().required('Mensagem é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await services.coreService.createContact(
          data.name,
          data.email,
          data.comment,
          data.phone || '',
        );

        formRef.current?.reset();

        addToast({
          type: 'success',
          title: 'Agradecemos seu contato',
          description: 'Sua mensagem é muito importante para nós!',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no Registro',
          description: 'Ocorreu um erro ao tentar registrar o Contato',
        });
      }
    },
    [addToast, services],
  );

  const handleAcessoRemoto = useCallback(
    async (data: any) => {
      try {
        formRefAcess.current?.setErrors({});

        await api.post('api/pjtacom/access-permission/', {
          password: `${data?.senha}`,
        });
        addToast({
          type: 'success',
          title: 'Solicitação realizada.',
          description:
            'Sua solicitação foi realizada. Favor entrar em contato com o SAC e informar!',
        });
        setModalRemoteAcess(false);
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro Favor solicitar novamente',
          description:
            'Caso o erro persista entre em contato com o nosso SAC .',
        });
      }
    },
    [addToast, services],
  );
  const handleAcessoRemotoCancel = useCallback(
    async (data: any) => {
      try {
        formRefAcess.current?.setErrors({});

        await api.delete('api/pjtacom/access-permission/');

        addToast({
          type: 'success',
          title: 'Solicitação realizada.',
          description:
            'Sua solicitação foi realizada e a permissão de Acesso Remoto foi cancelada!',
        });
        setModalRemoteAcessCancel(false);
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro Favor solicitar novamente',
          description:
            'Caso o erro persista entre em contato com o nosso SAC .',
        });
      }
    },
    [addToast, services],
  );

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>Fale Conosco</Title>
        </Column>
      </Row>
      <Row>
        <Column small="2" medium="2" large="2">
          <InfoContainer
            style={{ cursor: 'pointer' }}
            onClick={() => setShowManual(true)}
          >
            <InfoItem className="suporte">
              {/* <AiOutlineInfoCircle size={40} /> */}
              <span className="info">&#9432;</span>
              <span>
                Já conferiu se a sua dúvida está prevista no manual?
                <strong> Clique aqui </strong>
                para consultar as perguntas frequentes!
              </span>
            </InfoItem>
          </InfoContainer>
        </Column>
        <Column small="10" medium="10" large="10">
          <Main>
            <Content>
              <GridContainer>
                <FlexContainer>
                  <div className="section-contact">
                    <h2>Queremos ouvir você!</h2>
                    <p>Entre em contato para dúvidas ou mais informações</p>
                    <span>
                      <ImLocation2 />
                      <span className="text">Rua Aquiles Lobo 504 - </span>
                      <br />
                      <span className="bairro">Floresta - BH</span>
                    </span>
                    <span>
                      <FaPhoneAlt />
                      <span className="text">(31) 3248-7300</span>
                    </span>
                    <span>
                      <GrMail />
                      <span className="text">sac@transfacil.com.br</span>
                    </span>
                    <span>
                      <span className="medias">
                        <a
                          href="https://www.facebook.com/oficialtransfacil"
                          target="blank"
                        >
                          <img src={framefacebook} alt="facebook" />
                        </a>
                        <a
                          href="https://api.whatsapp.com/send?phone=553132487300&text=Olá%20Transfácil"
                          target="blank"
                        >
                          <img src={framewhatsapp} alt="whatsapp" />
                        </a>
                        <a href="https://t.me/transfaciloficial" target="blank">
                          <img src={frametelegram} alt="telegram" />
                        </a>
                      </span>
                    </span>
                  </div>
                </FlexContainer>
                <FlexContainer>
                  <Form ref={formRef} onSubmit={handleSubmit}>
                    <FormWrapper>
                      <Input name="name" placeholder="Digite o seu nome" />
                      <Input name="email" placeholder="Digite o seu email" />
                      <Input name="phone" placeholder="Digite o seu telefone" />
                      <div className="mensagem">
                        <Input
                          multiline
                          className="input-mensagem"
                          name="comment"
                          placeholder="Escreva a sua mensagem"
                        />
                      </div>
                      <Button
                        type="submit"
                        color="orange"
                        padding="2"
                        className="button"
                      >
                        ENVIAR
                      </Button>
                    </FormWrapper>
                  </Form>
                </FlexContainer>
              </GridContainer>
            </Content>
          </Main>
        </Column>
      </Row>
      {/* <Row className="titleWrapperAccess">
        <Column
          small="10"
          medium="10"
          large="10"
          className="TitleContainerAccess"
        >
          <Title>Acesso Remoto</Title>
        </Column>
      </Row>
      <Row>
        <Column small="10" medium="10" large="10">
          <Main>
            <Content>
              <GridContainer>
                <FlexContainer>
                  <div className="section-contact">
                    <h2>Deseja Permitir o Acesso Remoto?</h2>
                  </div>
                </FlexContainer>
              </GridContainer>
              <GridContainer>
                <FlexContainer>
                  <p>
                    Caso deseja dar permissão Clique em Acesso Remoto para
                    permitir!
                  </p>
                  <Button
                    color="purple"
                    padding="2"
                    className="button"
                    onClick={() => setModalRemoteAcess(true)}
                  >
                    <RiCustomerService2Fill
                      style={{
                        color: 'var(--white)',
                      }}
                    />
                    Acesso remoto
                  </Button>
                </FlexContainer>
                <FlexContainer>
                  <p>
                    Caso deseja cancelar a permissão clique em Cancelar Acesso
                    para cancelar!
                  </p>
                  <Button
                    color="orange"
                    padding="2"
                    className="button"
                    onClick={() => setModalRemoteAcessCancel(true)}
                  >
                    <RiCustomerService2Fill
                      style={{
                        color: 'var(--white)',
                      }}
                    />
                    Cancelar Acesso
                  </Button>
                </FlexContainer>
              </GridContainer>
            </Content>
          </Main>
        </Column>
      </Row> */}
      {showManual && (
        <ManualModal
          show={showManual}
          title="Manual de Uso"
          handleClose={() => setShowManual(false)}
        />
      )}
      {/* {modalRemoteAcess && (
        <Modal
          handleClose={() => setModalRemoteAcess(false)}
          show={modalRemoteAcess}
          title="Acesso Remoto"
        >
          <ModalRemoteAcess>
            <p className="TextoAcesso">
              Deseja permitir o acesso remoto ao seu usuário? Se sim favor
              preencher abaixo e clicar em Permitir Acesso Remoto. Caso
              contrario basta fechar este PopUp.
            </p>
            <FlexContainer
              style={{
                alignItems: 'center',
                alignContent: 'center',
                justifyItems: 'center',
              }}
            >
              <Form ref={formRefAcess} onSubmit={handleAcessoRemoto}>
                <FormWrappeEspecial>
                  <div className="remotes">
                    <Input
                      name="senha"
                      type="password"
                      className="inputremote"
                      placeholder="Digite o sua senha"
                    />
                    <Button
                      type="submit"
                      color="purple"
                      padding="2"
                      className="button"
                    >
                      <RiCustomerService2Fill />
                      Permitir Acesso Remoto
                    </Button>
                  </div>
                </FormWrappeEspecial>
              </Form>
            </FlexContainer>
          </ModalRemoteAcess>
        </Modal>
      )}
      {modalRemoteAcessCancel && (
        <Modal
          handleClose={() => setModalRemoteAcessCancel(false)}
          show={modalRemoteAcessCancel}
          title="Acesso Remoto"
        >
          <ModalRemoteAcess>
            <p className="TextoAcesso">
              Deseja cancelar a permissão de Acesso Remoto? Se sim, clique em
              Cancelar Acesso Remoto! Caso contrario basta fechar este PopUp.
            </p>
            <FlexContainer
              style={{
                alignItems: 'center',
                alignContent: 'center',
                justifyItems: 'center',
              }}
            >
              <Form ref={formRefAcess} onSubmit={handleAcessoRemotoCancel}>
                <FormWrappeEspecial>
                  <div className="remote">
                    <Button
                      type="submit"
                      color="purple"
                      padding="2"
                      className="button"
                    >
                      <RiCustomerService2Fill />
                      Cancelar Acesso Remoto
                    </Button>
                  </div>
                </FormWrappeEspecial>
              </Form>
            </FlexContainer>
          </ModalRemoteAcess>
        </Modal>
      )} */}
    </Container>
  );
};

export default Suporte;
